
document.addEventListener('DOMContentLoaded', () => {
	
	const carousel_infoColloqui = new carousel(".container_carousel", ".carousel");
	
	carousel_infoColloqui.initiateCarousPosition();
	
	carousel_infoColloqui.registerCarousListeners();
	
	window.addEventListener("load", () => {
		carousel_infoColloqui.enabCarouselZoomIn("(orientation: portrait)");
	});
	
	window.addEventListener("resize", () => {
		carousel_infoColloqui.enabCarouselZoomIn("(orientation: portrait)");
	});

	screen.orientation.addEventListener("change", () => {
		carousel_infoColloqui.enabCarouselZoomIn("(orientation: portrait)");
	});
	
	document.addEventListener("scroll", () => {
		carousel_infoColloqui.carouselZoomIn("2.0");
	});
	
});

///////////////////////////////////// CLASS DEFINITION //////////////////////////////////////////////////////////////////////

class carousel {
	constructor(carouselContainerSelector, carouselSelector) {
		this.carousDomEl = document.querySelector(carouselSelector);
		this.carousContainerDomElSelector = carouselContainerSelector;
		this.carousContainerDomEl = document.querySelector(carouselContainerSelector);
		this.numCarousPanels = 0;
		this.tgtPanel = 0;
		this.styleDomEl = null;
		this.createdStyle4CarousZoomIn = false;
	}
	
	rotateCarousel() {
		let panelAngleDeg = 360/this.numCarousPanels;
		let transform_val = `translateZ(-25.98vw) rotateY(${panelAngleDeg*this.tgtPanel}deg)`;

//console.log(transform_val);
		this.carousDomEl.style.setProperty('transform', transform_val);
	}
	
	initiateCarousPosition() {
		const carousPanelsDomEl = this.carousDomEl.querySelectorAll(".panel");
		this.numCarousPanels = carousPanelsDomEl.length;
console.log("numCarousPanels = " + this.numCarousPanels);

		this.tgtPanel = 0;
		this.rotateCarousel();
	}
	
	rotateCarousBwd() {
		this.tgtPanel--;
console.log("tgtPanel = " + this.tgtPanel);
		this.rotateCarousel();
	}
	
	rotateCarousFwd() {
		this.tgtPanel++;
console.log("tgtPanel = " + this.tgtPanel);
		this.rotateCarousel();
	}
	
	registerCarousListeners() {
console.log("carousContainerDomEl content = " + this.carousContainerDomEl.innerHTML);	
console.log("carousContainer button = " + this.carousContainerDomEl.querySelector(".carousel_butBwd"));	
		this.carousContainerDomEl.querySelector(".carousel_butBwd").addEventListener('click', () => { 
		this.rotateCarousBwd();
		});
		
		this.carousContainerDomEl.querySelector(".carousel_butFwd").addEventListener('click', () => {
			this.rotateCarousFwd();
		});
				
	}
	
	enabCarouselZoomIn(matchMediaCond) {
	
		let headDiv = document.getElementsByTagName("head")[0];
		
		if (window.matchMedia(matchMediaCond).matches)
			{
				if ( this.createdStyle4CarousZoomIn === false )
					{
						this.styleDomEl = document.createElement("style");
						headDiv.appendChild(this.styleDomEl);
						this.createdStyle4CarousZoomIn = true;
					}
console.log("headDiv.innerHTML = " + headDiv.innerHTML);
			}
		else
			{
				if ( this.createdStyle4CarousZoomIn === true )
					{
						this.styleDomEl.remove();
						this.createdStyle4CarousZoomIn = false;
					}
			}
	}	
			
	carouselZoomIn(multfactor) {
		
		console.log(window.scrollY);
		console.log(window.innerHeight);

		let pageDiv = document.querySelectorAll(".pageMainSection > div");
		let footerDiv = document.getElementsByTagName("footer")[0];
				
		if ( (window.scrollY + (window.innerHeight*0.75) >= pageDiv[4].getBoundingClientRect().top + window.scrollY ) || 
			(footerDiv.clientHeight + pageDiv[4].clientHeight + pageDiv[5].clientHeight <= window.innerHeight*0.25) )
		{
			this.styleDomEl.innerHTML = `
				${this.carousContainerDomElSelector} {
					transform: translateX(100%) scale(${multfactor});
					transform-origin: 100% 100%;
					transition-property: transform;
					transition-duration: 3s;
				}		
				.image_orient_mirrored {
					transform: rotateY(180deg) translateX(-100%);
					transition-property: transform;
					transition-duration: 3s;
				}
				.pageMainSection {
					overflow: hidden;
				}`
		}
		
	//	else if (window.scrollY + (window.innerHeight*0.75) <= pageDiv[3].getBoundingClientRect().top + window.scrollY )
		else if (window.scrollY + (window.innerHeight*0.75) <= 
		((pageDiv[3].getBoundingClientRect().top + pageDiv[4].getBoundingClientRect().top) / 2) + window.scrollY )
			{
			this.styleDomEl.innerHTML = `
				${this.carousContainerDomElSelector} {
					transform: translateX(0%) scale(1);
					transition-property: transform;
					transform-origin: 100% 100%;
					transition-duration: 3s;
				}		
				.image_orient_mirrored {
					transform: rotateY(180deg) translateX(0%);
					transition-property: transform;
					transition-duration: 3s;
				}
				.pageMainSection {
					overflow: hidden;
				}`
		}
	}
}
	
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////// FUNCTIONS DEFINITIONS //////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////